import { cloneElement } from "react";
import { normalizeSize } from "./size";
import { mergeProps } from "./mergeProps";
export function augmentElement(element, newProps) {
  const augmentedProps = mergeProps({ ...element.props,
    ref: element.ref
  }, newProps);
  return /*#__PURE__*/cloneElement(element, augmentedProps);
}
export function createEmbeddableAdapter(sizeAdapter) {
  return (element, {
    size,
    ...props
  }) => {
    const newProps = { ...props,
      size: sizeAdapter[normalizeSize(size)]
    };
    return augmentElement(element, newProps);
  };
}